export const estimationResultStyle = () => ({

  '& .estimation-result, .kpiestimation-result': {
    marginTop: 35,
    minHeight: 88,
    width: '100%',

    '& .panel-heading': {
      border: 0,
    },

    '& .panel-body': {
      padding: 0,

      '& .form-group': {
        margin: 0,
        width: 250,
        float: 'left',
        border: '1px solid #EFEDEB',

        '& .control-label': {
          marginTop: 0,
          width: 250,
          borderBottom: '1px solid #EFEDEB',
          padding: 8,

          '& label': {
            width: 210,
            fontWeight: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },

          '& .helpbutton': {
            display: 'inline-block',
            marginTop: 5,
            verticalAlign: 'top',
          },
        },

        '& .form-control-static': {
          width: '100%',
          height: 44,
          lineHeight: '44px',
          textAlign: 'left',
        },
      },
    },

    '& .estimated-clicks, .estimated-impressions, .estimated-spend, .estimated-position, .estimated-CTR, .estimated-avgCPC': {
      display: 'inline-block',
      float: 'none',
    },
  },

});
